"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var axios_1 = __importDefault(require("axios"));
var dialog_store_1 = __importDefault(require("~/stores/dialog_store"));
var ENDPOINT = '/api/reviews/';
var LIMIT = 10;
var ReviewSearchResultStore = /** @class */ (function () {
    function ReviewSearchResultStore(searchWords) {
        this.searchWords = '';
        this.totalCount = 0;
        this.reviews = [];
        this.searchWords = searchWords;
    }
    ReviewSearchResultStore.prototype.init = function () {
        this.load(5);
    };
    ReviewSearchResultStore.prototype.loadNext = function () {
        this.load(LIMIT);
    };
    Object.defineProperty(ReviewSearchResultStore.prototype, "hasNextPage", {
        get: function () {
            return this.totalCount > this.reviews.length;
        },
        enumerable: false,
        configurable: true
    });
    ReviewSearchResultStore.prototype.load = function (limit) {
        var _this = this;
        axios_1.default.get(ENDPOINT, { params: { search_word: this.searchWords, offset: this.reviews.length, limit: limit } })
            .then(function (response) {
            _this.reviews = __spreadArray(__spreadArray([], _this.reviews, true), response.data.data.reviews, true);
            _this.totalCount = response.data.data.total_count;
        })
            .catch(function () {
            dialog_store_1.default.showErrorDialog();
        });
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ReviewSearchResultStore.prototype, "totalCount", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], ReviewSearchResultStore.prototype, "reviews", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ReviewSearchResultStore.prototype, "init", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ReviewSearchResultStore.prototype, "loadNext", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ReviewSearchResultStore.prototype, "hasNextPage", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], ReviewSearchResultStore.prototype, "load", null);
    return ReviewSearchResultStore;
}());
exports.default = ReviewSearchResultStore;
